var React = require('react');

function Inactive (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.915 4.402H11.5v2H10v4.39a4.231 4.231 0 0 1-4.23 4.23h-.54A4.231 4.231 0 0 1 1 10.791v-5.54a4.231 4.231 0 0 1 4.23-4.23h.54a4.235 4.235 0 0 1 4.145 3.38zm-4.64-1.38A2.276 2.276 0 0 0 3 5.295v5.45a2.276 2.276 0 0 0 2.275 2.275h.45A2.276 2.276 0 0 0 8 10.746v-5.45a2.276 2.276 0 0 0-2.275-2.275h-.45zM15 18.901l-3.5-3.5h7l-3.5 3.5zm0-14.557l1.943-1.943L18 3.46l-1.943 1.943L18 7.345l-1.057 1.057L15 6.46l-1.943 1.943L12 7.345l1.943-1.943L12 3.46l1.057-1.057L15 4.345zm-1 8.057h2v2h-2v-2zm0-3h2v2h-2v-2zm-9.15-.73a.65.65 0 1 1 1.3 0 .65.65 0 0 1-1.3 0zM4 5.521a1.5 1.5 0 1 1 3.001-.002A1.5 1.5 0 0 1 4 5.522z","fill":"currentColor"}));
}

Inactive.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Inactive;

Inactive.default = Inactive;
